// Auto-generated index file for vocabulary
// This file combines all letter-based vocabulary files

import a from "./a.json";
import b from "./b.json";
import c from "./c.json";
import d from "./d.json";
import e from "./e.json";
import f from "./f.json";
import g from "./g.json";
import h from "./h.json";
import i from "./i.json";
import j from "./j.json";
import k from "./k.json";
import l from "./l.json";
import m from "./m.json";
import n from "./n.json";
import o from "./o.json";
import p from "./p.json";
import q from "./q.json";
import r from "./r.json";
import s from "./s.json";
import t from "./t.json";
import u from "./u.json";
import v from "./v.json";
import w from "./w.json";
import x from "./x.json";
import y from "./y.json";
import z from "./z.json";

// Combine all vocabulary words
const allWords = [
  ...a,
  ...b,
  ...c,
  ...d,
  ...e,
  ...f,
  ...g,
  ...h,
  ...i,
  ...j,
  ...k,
  ...l,
  ...m,
  ...n,
  ...o,
  ...p,
  ...q,
  ...r,
  ...s,
  ...t,
  ...u,
  ...v,
  ...w,
  ...x,
  ...y,
  ...z,
];

export default allWords;

// Export individual letter files for selective loading
export {
  a,
  b,
  c,
  d,
  e,
  f,
  g,
  h,
  i,
  j,
  k,
  l,
  m,
  n,
  o,
  p,
  q,
  r,
  s,
  t,
  u,
  v,
  w,
  x,
  y,
  z,
};
